export default theme => ({
    color: '#ACB8BE',
    fontWeight: theme.typography.fontWeight.base,
    opacity: 1,
});
